import * as Yup from 'yup';

export const loginSchema = (localization: any) => {
    return Yup.object().shape({
        email: Yup.string().trim().email(localization.errors.email).required(localization.errors.email_required),
        password: Yup.string().required(localization.errors.pwd_required)
    });
};
